var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { MenubarSpeakIcon } from './MenubarSpeakIcon';
import { runtime } from '../../../../classes/runtime/Runtime';
let MenubarSpeak_ = class MenubarSpeak_ extends React.PureComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    render() {
        const { app } = this.props;
        if (!runtime.availablePackages.Defer)
            return null;
        return (React.createElement("div", { style: {
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                cursor: 'pointer',
                height: 45,
                width: 45
            }, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, onClick: this.handleMouseClick },
            React.createElement(MenubarSpeakIcon, { app: app })));
    }
    handleMouseEnter() {
        this.props.app.menubar.menubarSpeak.isMenubarSpeakPopoverOpen = true;
        this.props.app.menubar.menubarSpeak.isMenubarSpeakIconHovered = true;
    }
    handleMouseLeave() {
        this.props.app.menubar.menubarSpeak.isMenubarSpeakIconHovered = false;
    }
    handleMouseClick() { }
};
__decorate([
    action.bound
], MenubarSpeak_.prototype, "handleMouseEnter", null);
__decorate([
    action.bound
], MenubarSpeak_.prototype, "handleMouseLeave", null);
__decorate([
    action.bound
], MenubarSpeak_.prototype, "handleMouseClick", null);
MenubarSpeak_ = __decorate([
    observer
], MenubarSpeak_);
export { MenubarSpeak_ };
